import { render, staticRenderFns } from "./menu-option.vue?vue&type=template&id=32d56d2b&"
import script from "./menu-option.vue?vue&type=script&lang=js&"
export * from "./menu-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports